import { OrdersState } from '@store/orders/orders.model';
import * as OrdersActions from '@store/orders/orders.actions';

export const ordersInitialState: OrdersState = {
  cart: null,
  offer: null,
  hazardOffer: null,
  cartInfo: null,
  cartSummary: null,
  cartSize: null,
  userCards: [],
  currentStripeCard: null,
  isNewCard: true,
  orders: [],
  order: null,
  currentView: null,
  isDescending: true,
  currentCard: null,
  promoError: false,
  communityInsightsOffer: null,
  buildingPermitsOffer: null,
  assessorMapOffer: null,
  foreclosureOffer: null,
  buildingSketchOffer: null,
  documentImageOffer: null
};

export function OrdersReducer(state: OrdersState = ordersInitialState, action: OrdersActions.All) {
  switch (action.type) {
    case OrdersActions.GET_CART_SUCCESS:
     return {
        ...state,
        cart: action.payload,
        cartSize: action.payload.cartItems.length,
        cartSummary: action.payload.cartSummary,
        promoError: false
      };
   case OrdersActions.GET_CART_SIZE_SUCCESS:
     return {
        ...state,
        cartSize: action.payload
      };
    case OrdersActions.PROMO_ERROR:
     return {
        ...state,
        promoError: action.payload
     };
    case OrdersActions.GET_OFFER_SUCCESS:
      return {
        ...state,
        offer: action.payload
      };
    case OrdersActions.GET_HAZARD_OFFER_SUCCESS:
      return {
        ...state,
        hazardOffer: action.payload
      };
    case OrdersActions.GET_COMMUNITY_INSIGHTS_OFFER_SUCCESS:
      return {
        ...state,
        communityInsightsOffer: action.payload
      }
    case OrdersActions.UPDATE_CART_SUCCESS: {
      const cartItems = action.payload.items ?? state.cart?.cartItems ?? [];
      const savedItems = action.payload.savedItems ?? state.cart?.savedItems ?? [];

      return {
        ...state,
        cart: {
          ...state.cart,
          cartItems,
          savedItems
        },
        cartSize: cartItems.length,
        cartInfo: action.payload
      };
    }

    case OrdersActions.GET_ALL_CARDS_SUCCESS:
      return {
        ...state,
        userCards: action.payload,
        currentStripeCard: null
      };
    case OrdersActions.GET_ORDERS_SUCCESS:
          return {
            ...state,
            orders: action.payload
          };
    case OrdersActions.SET_CURRENT_STRIPE_CARD:
      return {
        ...state,
        currentStripeCard: action.payload
      };
    case OrdersActions.RESET_CURRENT_STRIPE_CARD:
      return {
        ...state,
        currentStripeCard: null
      };
    case OrdersActions.SET_SELECTED_ORDER:
          return {
            ...state,
            order: action.payload
          };
    case OrdersActions.SET_IS_NEW:
      return {
        ...state,
        isNewCard: action.payload
      };
    case OrdersActions.SET_DESCENDING:
      return {
        ...state,
        isDescending: action.payload
       };
    case OrdersActions.SET_CURRENT_VIEW:
          return {
            ...state,
            currentView: action.payload
          };
    case OrdersActions.SUBMIT_ORDER_SUCCESS:
      return {
        ...state,
        cart: action.payload,
        order: action.payload,
        cartSize: 0
      };
    case OrdersActions.SAVE_CARD_SUCCESS:
      return {
        ...state,
        cart: action.payload,
        order: action.payload,
        cartSize: 0
       };
    case OrdersActions.CANCEL_ORDER_SUCCESS:
      return {
        ...state,
        orders: action.payload,
        currentView: 'cancelled'
      };
    case OrdersActions.SET_CURRENT_CARD:
      return {
        ...state,
        currentCard: action.payload
      };
    case OrdersActions.GET_BUILDING_PERMITS_OFFER_SUCCESS:
      return {
        ...state,
        buildingPermitsOffer: action.payload
      }
    case OrdersActions.GET_ASSESSOR_MAP_OFFER_SUCCESS:
      return {
        ...state,
        assessorMapOffer: action.payload,
      }
    case OrdersActions.GET_FORECLOSURE_OFFER_SUCCESS:
      return {
        ...state,
        foreclosureOffer: action.payload,
      }
    case OrdersActions.GET_BUILDING_SKETCH_OFFER_SUCCESS:
      return {
        ...state,
        buildingSketchOffer: action.payload,
      }
    case OrdersActions.GET_DOCUMENT_IMAGE_OFFER_SUCCESS:
        return {
          ...state,
          documentImageOffer: action.payload,
        }
    default: {
      return state;
    }
  }
}
